module.exports = __webpack_public_path__ + "media/3DSProjectDemo.9dc21d13.mp4";